import React from "react";
import Letop from "../allpages/Letop";

export default () => (
  <div>
    <div className="table">
      <table>
        <tr>
          <th className="col bor-bot" />
          <th>mannelijk</th>
          <th>vrouwelijk</th>
          <th>onzijdig</th>
        </tr>
        <tr>
          <th className="col">nom. ev.</th>
          <td>ipse</td>
          <td>ipsa</td>
          <td>ipsum</td>
        </tr>
        <tr>
          <th className="col">gen. ev.</th>
          <td>ipsius</td>
          <td>ipsius</td>
          <td>ipsius</td>
        </tr>
        <tr>
          <th className="col">dat. ev.</th>
          <td>ipsi</td>
          <td>ipsi</td>
          <td>ipsi</td>
        </tr>
        <tr>
          <th className="col">acc. ev.</th>

          <td>ipsum</td>
          <td>ipsam</td>
          <td>ipsum</td>
        </tr>
        <tr>
          <th className="col bor-bot">abl. ev.</th>
          <td className="bor-bot">ipso</td>
          <td className="bor-bot">ipsa</td>
          <td className="bor-bot">ipso</td>
        </tr>
        <tr>
          <th className="col">nom. mv.</th>
          <td>ipsi</td>
          <td>ipsae</td>
          <td>ipsa</td>
        </tr>
        <tr>
          <th className="col">gen. mv.</th>
          <td>ipsorum</td>
          <td>ipsarum</td>
          <td>ipsorum</td>
        </tr>
        <tr>
          <th className="col">dat. mv.</th>
          <td>ipsis</td>
          <td>ipsis</td>
          <td>ipsis</td>
        </tr>
        <tr>
          <th className="col">acc. mv.</th>
          <td>ipsos</td>
          <td>ipsas</td>
          <td>ipsa</td>
        </tr>
        <tr>
          <th className="col bor-bot">abl. mv.</th>
          <td className="bor-bot">ipsis</td>
          <td>ipsis</td>
          <td className="bor-bot">ipsis</td>
        </tr>
        <tr>
          <th className="col" />
          <td colSpan={3} className="center">
            <i>zelf</i>
          </td>
        </tr>
      </table>
    </div>

    <p>
      <Letop>
        Het rijtje van <b>ipse</b> gaat hetzelfde als het rijtje van{" "}
        <a href="aanwijzend-naamwoord">
          <b>iste</b>
        </a>
        .
      </Letop>
    </p>

    <div className="table">
      <table>
        <tr>
          <th className="col bor-bot" />
          <th>mannelijk</th>
          <th>vrouwelijk</th>
          <th>onzijdig</th>
        </tr>
        <tr>
          <th className="col">nom. ev.</th>
          <td>idem</td>
          <td>eadem</td>
          <td>idem</td>
        </tr>
        <tr>
          <th className="col">gen. ev.</th>
          <td>eiusdem</td>
          <td>eiusdem</td>
          <td>eiusdem</td>
        </tr>
        <tr>
          <th className="col">dat. ev.</th>
          <td>eidem</td>
          <td>eidem</td>
          <td>eidem</td>
        </tr>
        <tr>
          <th className="col">acc. ev.</th>

          <td>eundem</td>
          <td>eandem</td>
          <td>idem</td>
        </tr>
        <tr>
          <th className="col bor-bot">abl. ev.</th>
          <td className="bor-bot">eodem</td>
          <td className="bor-bot">eadem</td>
          <td className="bor-bot">eodem</td>
        </tr>
        <tr>
          <th className="col">nom. mv.</th>
          <td>eidem</td>
          <td>eaedem</td>
          <td>eadem</td>
        </tr>
        <tr>
          <th className="col">gen. mv.</th>
          <td>eorundem</td>
          <td>earundem</td>
          <td>eorundem</td>
        </tr>
        <tr>
          <th className="col">dat. mv.</th>
          <td>eisdem</td>
          <td>eisdem</td>
          <td>eisdem</td>
        </tr>
        <tr>
          <th className="col">acc. mv.</th>
          <td>eosdem</td>
          <td>easdem</td>
          <td>eadem</td>
        </tr>
        <tr>
          <th className="col bor-bot">abl. mv.</th>
          <td className="bor-bot">eisdem</td>
          <td>eisdem</td>
          <td className="bor-bot">eisdem</td>
        </tr>
        <tr>
          <th className="col" />
          <td colSpan={3} className="center">
            <i>dezelfde, hetzelfde</i>
          </td>
        </tr>
      </table>
    </div>

    <p>
      <Letop>
        Het rijtje van <b>idem</b> gaat hetzelfde als het rijtje van{" "}
        <a href="verwijzend-naamwoord">
          <b>is</b>
        </a>{" "}
        met <b>-dem</b> erachter. Als de vorm van{" "}
        <a href="verwijzend-naamwoord">
          <b>is</b>
        </a>{" "}
        op een <b>-m</b> eindigt, wordt het een <b>-n</b>.
      </Letop>
    </p>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/tables/bep-vnw.js